import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-steps',
  standalone: true,
  imports: [],
  template: '<ul [class]="classes"><ng-content></ng-content></ul>',
})
export class UiStepsComponent {
  /**
   * DaisyUI steps orientation.
   * Note: DaisyUI defaults to horizontal; `steps-vertical` makes it vertical.
   */
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  /**
   * If true, applies `md:steps-vertical` (desktop vertical, mobile unchanged).
   */
  @Input() verticalOnDesktop = false;

  /**
   * Extra classes (Tailwind/DaisyUI).
   */
  @Input() className = '';

  get classes(): string {
    const classes: string[] = ['steps'];

    if (this.orientation === 'vertical') {
      classes.push('steps-vertical');
    }

    if (this.verticalOnDesktop) {
      classes.push('md:steps-vertical');
    }

    if (this.className?.trim()) {
      classes.push(this.className.trim());
    }

    return classes.join(' ');
  }
}

